var _title, _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconApple = function SvgIconApple(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "4FFA9D44-92A4-44CA-8EC7-101400288399")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "You're-all-set",
    transform: "translate(-564.000000, -428.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-Store",
    transform: "translate(531.000000, 414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-apple",
    transform: "translate(33.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.734,15.355 C12.026,16.385 11.294,17.41 10.137,17.431 C8.999,17.453 8.634,16.761 7.336,16.761 C6.036,16.761 5.63,17.41 4.556,17.453 C3.439,17.494 2.59,16.339 1.876,15.313 C0.418,13.216 -0.694,9.382 0.802,6.794 C1.543,5.509 2.872,4.696 4.311,4.674 C5.407,4.654 6.442,5.411 7.112,5.411 C7.782,5.411 9.039,4.503 10.361,4.636 C10.914,4.659 12.466,4.858 13.463,6.31 C13.384,6.362 11.61,7.39 11.632,9.53 C11.654,12.088 13.882,12.938 13.909,12.95 C13.889,13.01 13.552,14.163 12.734,15.355 L12.734,15.355 Z M7.879,1.827 C8.491,1.113 9.525,0.582 10.379,0.547 C10.487,1.537 10.087,2.531 9.495,3.247 C8.902,3.961 7.931,4.517 6.978,4.443 C6.848,3.473 7.328,2.461 7.879,1.827 Z",
    id: "Shape"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconApple, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-apple.fe7985ef.svg";
export { ForwardRef as ReactComponent };